export default __webpack_public_path__ + "static/media/CodigoQR.38c34bc7.jpeg";